/**
 * Create and focus an invisible input immediately so that the device will show the keyboard to the user,
 * then subsequent programmatic calls to `.focus()` can be made and the keyboard will stay open.
 * Based on: https://stackoverflow.com/questions/12204571/mobile-safari-javascript-focus-method-on-inputfield-only-works-with-click/55652503#55652503
 */
export function createInvisibleInputToActivateKeyboard(container: HTMLElement = null): HTMLInputElement {
	// Create an invisible input to receive focus immediately so that the keyboard will be opened
	const invisibleInputForMobileKeyboard = document.createElement('input');
	invisibleInputForMobileKeyboard.setAttribute('type', 'text');
	invisibleInputForMobileKeyboard.className = 'cog-offscreen';

	// Make font size larger in order to disable auto-zoom on focus (on mobile devices)
	invisibleInputForMobileKeyboard.style.fontSize = '16px';

	// Support appending to a specified container element to mitigate browsers' auto-zoom/scroll behavior
	(container || document.body).prepend(invisibleInputForMobileKeyboard);

	// Focus so that the keyboard will open (and stay open) for subsequent async focus
	invisibleInputForMobileKeyboard.focus();

	return invisibleInputForMobileKeyboard;
}
